/***************************************************************************
 * ========================================================================
 * Copyright (c) 2026 Broadcom Inc. and/or its subsidiaries. All Rights Reserved. Broadcom Confidential.
 * ========================================================================
 */

angular.module('aviApp').directive('aviLoader', function() {
    return {
        restrict: 'A',
        template: '<div><i class="icon-loader sel-loader"></i></div>',
    };
});
